













import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { closeToViewportVertically } from '@/utils/viewport';

@Component
export default class SInfiniteLoader extends Vue {
  @Prop(Boolean) private isLoading?: boolean;
  @Prop(Boolean) private stopEmitting?: boolean = false;
  @Ref() private readonly loaderRef!: HTMLElement;

  public mounted() {
    // We should check that on initial render if we should trigger @infinite immediately
    // (for example if screen height is bigger than the printed page).
    // Do it in $nextTick, to wait for initial components to be rendered.
    this.$nextTick(() => {
      this.checkEndReached();
    });
  }

  private checkEndReached() {
    if (this.stopEmitting) return;
    const loader = this.loaderRef;
    if (!!loader && closeToViewportVertically(loader)) {
      this.$emit('infinite');
    }
  }
}
